import Vue from "vue";
import Router from "vue-router";
import Firebase from "firebase";
import store from "./store";
/* eslint-disable no-console */
Vue.use(Router);

var router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/maintenance",
      name: "maintenance",
      component: () => import("./views/MaintenancePage.vue"),
      meta: { isPublic: true }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/User/Login.vue"),
      meta: { isPublic: true }
    },
    {
      path: "/signup",
      name: "signUp",
      component: () => import("./views/User/SignUp.vue"),
      meta: { isPublic: true }
    },
    {
      path: "/passwordreset",
      name: "passwordReset",
      component: () => import("./views/User/PasswordReset.vue"),
      meta: { isPublic: true }
    },
    {
      path: "/nonmember",
      name: "nonMember",
      component: () => import("./views/User/NonmemberHome.vue"),
      meta: { isPublic: true }
    },
    {
      path: "/home",
      name: "home",
      component: () => import("./views/User/Home.vue")
    },
    {
      path: "/registuserinfo",
      name: "registUserInfo",
      component: () => import("./views/User/RegistUserInfo.vue"),
      meta: { isPublic: true }
    },
    {
      path: "/eventlist",
      name: "eventList",
      component: () => import("./views/User/EventList.vue")
    },
    {
      path: "/eventdetail/:eventNumber",
      name: "eventDetail",
      component: () => import("./views/User/EventDetail.vue")
    },
    {
      path: "/traininglist",
      name: "trainingList",
      component: () => import("./views/User/TrainingList.vue")
    },
    {
      path: "/trainingdetail/:scheduleNumber",
      name: "trainingDetail",
      component: () => import("./views/User/TrainingDetail.vue")
    },
    {
      path: "/reservationlist",
      name: "reservationList",
      component: () => import("./views/User/ReservationList.vue")
    },
    {
      path: "/userinfo",
      name: "userInfo",
      component: () => import("./views/User/UserInfo.vue")
    },
    {
      path: "/admin/login",
      name: "adminLogin",
      component: () => import("./views/Admin/AdminLogin.vue"),
      meta: { isPublic: true, isAdmin: true }
    },
    {
      path: "/admin/passwordreset",
      name: "adminPasswordReset",
      component: () => import("./views/Admin/AdminPasswordRest.vue"),
      meta: { isPublic: true, isAdmin: true }
    },
    {
      path: "/admin/home",
      name: "adminHome",
      component: () => import("./views/Admin/AdminHome.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/admin/traininglist",
      name: "adminTraininglist",
      component: () => import("./views/Admin/AdminTrainingList.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/admin/trainingdetail/:trainingId",
      name: "adminTrainingDetail",
      component: () => import("./views/Admin/AdminTrainingDetail.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/admin/schedulelist",
      name: "adminScheduleList",
      component: () => import("./views/Admin/AdminScheduleList.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/admin/scheduledetail/:scheduleNumber",
      name: "adminScheduleDetail",
      component: () => import("./views/Admin/AdminScheduleDetail.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/admin/reservedmemberlist/:scheduleNumber",
      name: "adminReservedMemberList",
      component: () => import("./views/Admin/AdminReservedMemberList.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/admin/memberList",
      name: "adminMemberList",
      component: () => import("./views/Admin/AdminMemberList.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/admin/memberdetail/:uid",
      name: "adminMemberDetail",
      component: () => import("./views/Admin/AdminMemberDetail.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/admin/fileupload",
      name: "adminFileUpload",
      component: () => import("./views/Admin/AdminFileUpload.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/admin/eventlist",
      name: "adminEventList",
      component: () => import("./views/Admin/AdminEventList.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/admin/eventdetail/:eventId",
      name: "adminEventDetail",
      component: () => import("./views/Admin/AdminEventDetail.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/admin/typelist",
      name: "adminTypeList",
      component: () => import("./views/Admin/AdminTypeList.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/admin/typedetail/:typeId",
      name: "adminTypeDetail",
      component: () => import("./views/Admin/AdminTypeDetail.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/admin/memberreservationlist/:uid",
      name: "adminMemberReservationList",
      component: () => import("./views/Admin/AdminMemberReservationList.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "/guest",
      component: () => import("./views/Guest/GuestTrainingList.vue"),
      meta: { isGuest: true }
    },
    {
      path: "/guest/trainingList",
      component: () => import("./views/Guest/GuestTrainingList.vue"),
      meta: { isGuest: true }
    },
    {
      path: "/guest/trainingdetail/:scheduleNumber",
      component: () => import("./views/Guest/GuestTrainingDetail.vue"),
      meta: { isGuest: true }
    },
    {
      path: "/guest/searchReservation",
      component: () => import("./views/Guest/searchReservation.vue"),
      meta: { isGuest: true }
    },
    {
      path: "/admin/*",
      component: () => import("./views/Admin/AdminHome.vue"),
      meta: { isAdmin: true }
    },
    {
      path: "*",
      component: () => import("./views/User/Home.vue")
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  let isPublic = to.matched.some(record => record.meta.isPublic);
  let isAdmin = to.matched.some(record => record.meta.isAdmin);
  let isGuest = to.matched.some(record => record.meta.isGuest);
  if(process.env.VUE_APP_MAINTENANCE_MODE === "true" && !isAdmin && to.name !== "maintenance"){
    next({ path: "/maintenance" });
    return;
  }
  await store.dispatch(
    "loginStore/loginInfo/loginInfoStore/setGuest",
    isGuest
  );
  if(process.env.VUE_APP_MAINTENANCE_MODE === "true"){
    if(!isAdmin){
      if(to.name === "maintenance"){
        next();
        return;
      }else{
        next({ path: "/maintenance" });
        return;
      }
    }
    next();
  }
  if (!isPublic && !isGuest) {
    await Firebase.auth().onAuthStateChanged(async function(user) {
      if (user) {
        await store.dispatch(
          "loginStore/loginInfo/loginInfoStore/setUserInfo",
          user
        );
        let isAdminUser =
          store.getters["loginStore/loginInfo/loginInfoStore/isAdmin"];
        if (isAdmin && !isAdminUser) {
          await Firebase.auth().signOut();
          await store.dispatch(
            "loginStore/loginInfo/loginInfoStore/setUserInfo",
            null
          );
          await store.dispatch(
            "loginStore/loginInfo/loginInfoStore/setSignIn",
            false
          );
          next({ path: "/admin/login" });
          return;
        }
        if (!isAdmin && isAdminUser) {
          await Firebase.auth().signOut();
          await store.dispatch(
            "loginStore/loginInfo/loginInfoStore/setUserInfo",
            null
          );
          await store.dispatch(
            "loginStore/loginInfo/loginInfoStore/setSignedIn",
            false
          );
          console.log("gobackLogin");
          next({ path: "/login" });
          return;
        }
        await store.dispatch(
          "loginStore/loginInfo/loginInfoStore/setSignedIn",
          user.uid ? true : false
        );
        next();
      } else {
        await Firebase.auth().signOut();
        await store.dispatch(
          "loginStore/loginInfo/loginInfoStore/setUserInfo",
          null
        );
        await store.dispatch(
          "loginStore/loginInfo/loginInfoStore/setSignedIn",
          false
        );
        if (isAdmin) {
          next({ path: "/admin/login" });
        } else {
          next({ path: "/login" });
        }
      }
    });
  } else {
    next();
  }
});
export default router;
